import { getImageUrlFileUseCase } from '@src/main/shared/application/download-file.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { createFileHttpRepository } from '@src/main/shared/infrastructure/FileHttpRepository';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useGetUrlFile = (keyFile?: string, fileName?: string) => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFileHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);
  return useQuery({
    queryKey: ['file', keyFile],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not initialized');
      return await getImageUrlFileUseCase(keyFile!, fileName!, repository);
    },
    enabled: !!keyFile && !!fileName,
  });
};
